/**
 * Provide a default hook since not everyone needs to config this.
 */
var useDefaultCSP = function useDefaultCSP() {
  return {};
};
export default useDefaultCSP;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/cssinjs-utils/es/hooks/useCSP.js
// module id = 1481
// module chunks = 0